import { render, staticRenderFns } from "./HomeSupport.vue?vue&type=template&id=79c480d0"
import script from "./HomeSupport.vue?vue&type=script&lang=js"
export * from "./HomeSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports